<template>
  <div id="buyList">
    <div class="thead">Покупка ROBUX (по списку)</div>
    <div class="sub">
      Курс обмена:
      <span class="t-white">
        1 <span class="t-green">₽</span> - {{ $root.common.rate }}
        <span class="t-red">R$</span>
      </span>
	</div>
	<textarea
	  v-model="list"
	  @input="_ => amount = null"
      rows="5"
      class="wa bg-darker"
      placeholder="https://www.roblox.com/game-pass/109114798/apple
https://www.roblox.com/game-pass/109114798/apple
https://www.roblox.com/game-pass/109114798/apple
https://www.roblox.com/game-pass/109114798/apple"
    ></textarea>
    <button class="fs24" @click="getAmount">Посчитать цену</button>
	<PriceCalculator disabled="true" v-if="amount" :rate="$root.common.rate" :preamount="amount" />	
	<div class="sector bg-darker wa">
	  <div class="fs30 t-light">Промокод (если есть)</div>
      <input type="text" class="bg-darker wa" v-model="promo" />
    </div>
    <pre class="sub wa">
Наша система автоматически купит ваш gamepass как можно скорее.
При покупки R$ будет использован платежный шлюз lava.
Пожалуйста ознакомьтесь с правилами использования сервиса.</pre>
    <PayWays @method="x => method = x"></PayWays>
    <button class="fs30" v-if="amount" @click="order">Оплатить</button>
  </div>
</template>

<script>
import { GetGamepassInfoRequest } from "@/protos/user_pb.js";
import PayWays from "@/components/PayWays";

import PriceCalculator from "@/components/PriceCalculator";
import Utils from "@/utils.js";

export default {
  components: {
    PayWays,
    PriceCalculator,
  },

  data() {
	return {
	  method: "nicepay",
    ids: [],
	  list: "",
	  amount: null,
	  showAmount: null,
	  email: "",
	  promo: ""
	}
  },

  methods: {
	order() {
	  this.$root.startBuildingOrder({ method: this.method, gamepassesIds: this.ids, amount: this.amount, email: this.email, ignoreCheck: true, promo: this.promo })
	},

	getAmount() {
	  this.ids = []
	  let num = 0
	  for (const line of this.list.split("\n")) {
		const id = Utils.parseGamepassID(line)

		if (!id)
		  return this.$root.toast.error(`Неправильная ссылка на строке ${num}: ${line}`)

		this.ids.push(id[1])
		num++
	  }

	  if (!this.ids.length)
		return

	  let r = new GetGamepassInfoRequest()
	  r.setIdsList(this.ids)

	  this.$root.client.getGamepassInfo(r, {}, (err, resp) => {
		if (err) return this.$root.toast.error(`Ошибка ${err}`)

		let amount = 0
		for (const gp of resp.getGamepassesList()) {
		  const price = gp.getPrice()
		  if (price > 5000) {
			return this.$root.toast.error(`Один из gamepass имеет слишком большую цену. Максимум цена за gamepass: 5000`)
		  }
		  amount += Utils.takeCommision(price)
		}

		this.amount = amount
	  })
	}
  },
};
</script>

<style scoped lang="scss">
#buyList {
  max-width: 1022px;
}
</style>
